import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";

type Props = {
  title: string;
  description?: string;
  showTokenFromParams?: string;
};

export function PlaceholderPage({ title, description, showTokenFromParams }: Props) {
  const params = useParams();
  const token = showTokenFromParams ? params[showTokenFromParams] : undefined;

  return (
    <div className="mx-auto max-w-4xl px-4 py-10 md:px-8 md:py-16">
      <div className="text-xs uppercase tracking-widest text-muted-foreground">
        Placeholder
      </div>
      <h1 className="mt-2 font-display text-4xl font-bold tracking-tight">
        {title}
      </h1>
      {description && (
        <p className="mt-3 max-w-2xl text-muted-foreground">{description}</p>
      )}
      {token && (
        <div className="mt-4 inline-flex items-center gap-2 rounded-md border border-border bg-card px-3 py-1.5 text-xs">
          <span className="text-muted-foreground">Token:</span>
          <code className="font-mono text-foreground">{token}</code>
        </div>
      )}
      <div className="mt-8 flex items-center gap-3 rounded-xl border border-dashed border-border p-6 text-sm text-muted-foreground">
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
        <span>Real content ships in a later task.</span>
      </div>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        Back home
      </Link>
    </div>
  );
}
